// A live token that failed, or a prior Xero link whose token is already gone.
// missing_token means this user has never connected — leave that to an explicit Connect action.
export const XERO_REAUTH_REASONS = [
  'refresh_failed',
  'missing_refresh_token',
  'missing_scopes',
  'no_tenants',
  'tenant_not_pinned',
  'member_tenant_mismatch',
  'unexpected_error',
  'connection_broken'
];

// Operational pages. A broken Xero token redirects to Xero only after the user opens one of these.
// The dashboard and settings stay put so they can disconnect a pinned organisation first.
export const XERO_FUNCTION_ROUTES = new Set([
  'direct-bill-import',
  'import-bills-from-xero',
  'import-from-jobtread',
  'process-invoices',
  'sync-bills-from-jobtread'
]);

export function isXeroReauthReason(reason) {
  return XERO_REAUTH_REASONS.includes(reason || '');
}

export function shouldAutoRedirectToXero(data, activeRoute) {
  if (!data?.redirectUrl) return false;
  if (!isXeroReauthReason(data.reason)) return false;
  return XERO_FUNCTION_ROUTES.has(activeRoute);
}
